import { Size } from "./types";

export const FontSize = {
  [Size.SMALL]: "10px",
  [Size.MEDIUM]: "12px",
};

export const IconSize = {
  [Size.SMALL]: "8px",
  [Size.MEDIUM]: "10px",
};

export const reactJsonProps = {
  name: null,
  enableClipboard: false,
  displayDataTypes: false,
  displayArrayKey: true,
  quotesOnKeys: false,
  collapsed: 1,
  indentWidth: 2,
  collapseStringsAfterLength: 30,
};
